import TextLink from "hardcover-ui/components/TextLink";
import moment from "moment";
import ActivityType from "types/ActivityType";

export default function ActivityLink({ activity }: { activity: ActivityType }) {
  return (
    <TextLink
      variant="secondary"
      underline={false}
      href={`/@${activity.user.username}/activity/${activity.id}`}
    >
      {moment.utc(activity.createdAt).fromNow()}
    </TextLink>
  );
}
